<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toc"><a href="#/xhtml/03_Chapter01">Equipment – machines</a></h2>
<h2 class="toc1"><em class="italic">Your key tools are your sewing machine, overlocker and their presser feet and needles</em></h2>
<h2 class="toc"><a href="#/xhtml/04_Chapter02">Tools</a></h2>
<h2 class="toc1"><em class="italic">Using the correct tools will make your preparation and sewing more enjoyable</em></h2>
<h2 class="toc"><a href="#/xhtml/05_Chapter03">Fabric</a></h2>
<h2 class="toc1"><em class="italic">Your choice of fabric will determine the look of your garment</em></h2>
<h2 class="toc"><a href="#/xhtml/06_Chapter04">Interfacing</a></h2>
<h2 class="toc1"><em class="italic">Use the correct stabiliser for your fabric</em></h2>
<h2 class="toc"><a href="#/xhtml/07_Chapter05">Notions</a></h2>
<h2 class="toc1"><em class="italic">Buttons, zips, threads, braids and more are indispensable for clothing and accessories</em></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter06" title="Link target outside of Sample">Measurements</span></h2>
<h2 class="toc1"><em class="italic">Correct measurement is the key to a well fitting garment</em></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter07" title="Link target outside of Sample">Patterns</span></h2>
<h2 class="toc1"><em class="italic">Understand your pattern and make small changes to achieve a perfect fit</em></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter08" title="Link target outside of Sample">Preparation – cutting out</span></h2>
<h2 class="toc1"><em class="italic">A good beginning is important for a good result</em></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter09" title="Link target outside of Sample">Marking</span></h2>
<h2 class="toc1"><em class="italic">Use the correct methods to transfer pattern markings onto the fabric</em></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter10" title="Link target outside of Sample">Pressing</span></h2>
<h2 class="toc1"><em class="italic">Well pressed seams are essential for good garment construction</em></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter11" title="Link target outside of Sample">Troubleshooting</span></h2>
<h2 class="toc1"><em class="italic">Hints and tips to keep your sewing running smoothly</em></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter12" title="Link target outside of Sample">Sewing techniques</span></h2>
<h2 class="toc1"><em class="italic">The most important steps to beautiful garments</em></h2>
<h2 class="toc"><span href="#/xhtml/15_Glossary" title="Link target outside of Sample">Glossary of terms</span></h2>
<div class="sidebar">
<p class="side-pt"><span class="bold">Sew</span> (definition)</p>
<p class="side-p">To join or to decorate pieces of fabric by means of a thread repeatedly passing through with a needle or similar implement</p>
</div>
<div class="img_container1">
<img alt="images" src="images/f0002-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?36cd0c41